<template>
  <v-container class="pa-0">
    <v-row id="seccionPlanes" class="header-row text-center">
      <v-col cols="12" md="10" lg="8" class="mx-auto">
        <h2 class="header-title">
          Atención médica de excelencia en nuestra red hospitalaria
        </h2>
        <p class="header-subtitle grey--text">
          Hospitales y especialistas comprometidos con tu salud y bienestar.
        </p>
      </v-col>
    </v-row>

    <!-- Detalle por hospital en cards -->
    <v-row justify="center" class="mb-16" dense>
      <v-col v-for="(hospital, index) in logos" :key="'card-' + index" cols="12" sm="12" md="8" lg="6">
        <v-card elevation="8" class="pa-3" style="background: rgba(255,255,255,0.1); color: white;">
       <v-img
          cover
          :src="hospital.imageError ? 'https://medicover.mx/img/hospitales/default.svg' : hospital.src"
          :alt="hospital.alt"
          height="160"
          class="rounded-lg"
          @error="hospital.imageError = true"
        ></v-img>
          <v-card-title class="font-weight-bold">{{ hospital.alt }}</v-card-title>
          <v-card-subtitle class="mb-2" style="font-style: italic; font-size: 0.9rem;">
            {{ hospital.nombre }}
          </v-card-subtitle>
          <v-card-text>
            <div><strong>Información:</strong></div>
            <div>{{ hospital.info }}</div>
            <div><strong>Dirección:</strong></div>
            <div>{{ hospital.address }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="azul_med" :href="`tel:${hospital.tel}`" dark small>
              Llamar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  data() {
    return {
      hoverIndex: null,
      logos: [
        {
          src: "https://medicover.mx/img/hospitales/h_angeles.jpg",
          alt: "Hospital Angeles",
          info: "Forma parte de nuestra Red Hospitalaria",
          address: "Calle, Antonio Aguilar #155, Burocratas del Estado, San Luis, S.L.P., México",
          nombre: "Hospital Ángeles",
          tel: 4448133797,
          imageError: false
        },
        {
          src: "https://medicover.mx/img/hospitales/h_starmedica.webp",
          alt: "Hospital Star Médica",
          info: "Forma parte de nuestra Red Hospitalaria",
          address: "General Mariano Arista No. 735 C.P. 78250 Barrio de Tequisquiapan, San Luis Potosí",
          nombre: "Hospital Star Médica",
          tel: 4448123737,
          imageError: false
        },
        {
          src: "https://medicover.mx/img/hospitales/h_labene.jpg",
          alt: "HHospital La Bene San Luis",
          info: "Forma parte de nuestra Red Hospitalaria",
          address: "Av. Venustiano Carranza 1090, De Tequisquiapan, 78250 San Luis Potosí, S.L.P.",
          nombre: "Hospital La Bene San Luis",
          tel: 4448134048,
          imageError: false
        },
        {
          src: "https://medicover.mx/img/hospitales/h_dls.jpg",
          alt: "Hospital de Especialidades Médicas de la Salud",
          info: "Forma parte de nuestra Red Hospitalaria",
          address: "Av. Benito Juárez #1210 Fracc. Valle Dorado C.P. 78399 México, San Luis Potosí, S.L.P.",
          nombre: "Hospital de Especialidades Médicas de la Salud",
          tel: 4441672000,
          imageError: false
        },
        {
          src: "https://medicover.mx/img/hospitales/h_lomas.jpg",
          alt: "Hospital Lomas de San Luis Internacional",
          info: "Hospital Lomas de San Luis Internacional forma parte de la Red Hospitalaria.",
          address: "Av. palmira No. 600 Col. Villas del Pedregal C.P. 78218 México, San Luis Potosí, S.L.P.",
          nombre: "Hospital Lomas de San Luis Internacional",
          tel: 4441025900,
          imageError: false
        }
      ]
    };
  },
  methods: {
    contactar() {
      alert('Gracias por tu interés, pronto un asesor se pondrá en contacto.');
    },
    verDetalle(hospital) {
      alert(`Más información sobre ${hospital.alt}:\n${hospital.info}\nDirección: ${hospital.address}`);
      // Aquí puedes abrir modal o redirigir a detalle
    }
  }
};
</script>

<style scoped></style>
